import { useState } from 'react';
import {
  CONSENT_BANNER_ENABLED, CONSENT_PLACEHOLDER_COPY,
  getConsentChoice, setConsentChoice,
} from '@/lib/growthIntel/consent';

/**
 * Consent banner — built but DISABLED by default.
 *
 * The copy below is a PLACEHOLDER marked "requires legal review" and must NOT
 * be published as-is. Enable only after legal review, and only when the site is
 * running in 'opt_in' consent mode.
 */
export default function ConsentBanner() {
  const [dismissed, setDismissed] = useState(() => getConsentChoice() !== 'unknown');

  if (!CONSENT_BANNER_ENABLED || dismissed) return null;

  const decide = (choice: 'granted' | 'denied') => {
    setConsentChoice(choice);
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-slate-200 px-4 py-4 md:px-6">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-sm text-slate-600 flex-1">{CONSENT_PLACEHOLDER_COPY}</p>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={() => decide('denied')}
            className="px-4 py-2 border border-slate-300 text-slate-700 rounded-md text-sm font-medium hover:bg-slate-50 whitespace-nowrap cursor-pointer"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => decide('granted')}
            className="px-4 py-2 bg-teal-600 text-white rounded-md text-sm font-medium hover:bg-teal-700 whitespace-nowrap cursor-pointer"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}